import React from 'react';

import { IconButton } from '@mui/material';

import Link from './Link';

type ButtonLinkProps = Omit<Parameters<typeof IconButton>[0], 'component'>;

type Props = ButtonLinkProps & {
  href: string;
  target?: string;
};

export default function IconButtonLink({ href, target, ...props }: Props): JSX.Element {
  return (
    <Link href={href} color="inherit" target={target}>
      <IconButton {...props} />
    </Link>
  );
}
